import { Board } from "../Model/Board";
import { Cell } from "../Model/Cell";
export class BoardsFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createBoard(id, gameId, playerId, hasFigure, hasBingo, cells) {
        return new Board(this.eventsChannelFactory, id, gameId, playerId, hasFigure, hasBingo, cells);
    }
    createBoardFromDto({ id, gameId, playerId, hasFigure, hasBingo, cells }) {
        return this.createBoard(id, gameId, playerId, hasFigure, hasBingo, cells.map((cell) => cell ? new Cell(cell.number, cell.checked) : null));
    }
}
